import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  searchLDSproperties,
  lDSpropertiesByCityAndTotalAssessedValue,
  lDSpropertiesByStateAndTotalAssessedValue,
  lDSpropertiesByCountyAndTotalAssessedValue,
} from "./graphql/queries";
import { getScreenSize } from "./helper/responsiveness";

import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import PropertyDetail from "./PropertiyDetail";
// import MapBox from "./MapBox";

const ListLDSProperties = () => {
  const [landUseDescription, setLandUseDescription] = useState("");
  const [detailShow, setDetailShow] = useState(false);
  // const [mapShow, setMapShow] = useState(false);
  const [searchStr, setSearchStr] = useState("");
  const [filterStr, setFilterStr] = useState("City");
  const [LDSProperties, setLDSProperties] = useState([]);
  // const [currentProperty, setCurrentProperty] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [nextToken, setNextToken] = useState("");
  const [pid, setpid] = useState("");
  const { isMobile } = getScreenSize();

  useEffect(() => {
    fetchLDSproperties();
    return () => setLDSProperties([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let limitNum = 100;
  const fetchLDSproperties = async () => {
    try {
      setIsLoading(true);
      const ldsPropertiesData = await API.graphql(
        graphqlOperation(searchLDSproperties, {
          limit: limitNum,
          sort: {
            direction: "desc",
            field: "TotalAssessedValue",
          },
        })
      );
      setNextToken(ldsPropertiesData.data.searchLDSproperties.nextToken);
      const ldsProperties = ldsPropertiesData.data.searchLDSproperties.items;
      setLDSProperties(ldsProperties);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      //   setErrorType(error.errors[0].errorType);
    }
  };
  const handleShowDetail = (p) => {
    setDetailShow(true);
    setLandUseDescription(p.LandUseDescription);
    setpid(p.id);
  };
  // const handleShowMap = (p) => {
  //   setMapShow(true);
  //   setCurrentProperty(p);
  // };
  const handleSubmitSearchString = async (event) => {
    event.preventDefault();

    if (!searchStr) {
      fetchLDSproperties();
    } else if (filterStr === "City" && searchStr) {
      setIsLoading(true);
      await API.graphql(
        graphqlOperation(lDSpropertiesByCityAndTotalAssessedValue, {
          limit: limitNum,
          City: searchStr.toUpperCase(),
          sortDirection: "DESC",
        })
      ).then((res) => {
        const ldsProperties = [];
        ldsProperties.push(
          ...res.data.LDSpropertiesByCityAndTotalAssessedValue.items
        );
        setLDSProperties(ldsProperties);
        setNextToken(
          res.data.LDSpropertiesByCityAndTotalAssessedValue.nextToken
        );
        setIsLoading(false);
      });
    } else if (filterStr === "State" && searchStr) {
      setIsLoading(true);
      await API.graphql(
        graphqlOperation(lDSpropertiesByStateAndTotalAssessedValue, {
          limit: limitNum,
          State: searchStr.toUpperCase(),
          sortDirection: "DESC",
        })
      ).then((res) => {
        const ldsProperties = [];
        ldsProperties.push(
          ...res.data.LDSpropertiesByStateAndTotalAssessedValue.items
        );
        setLDSProperties(ldsProperties);
        setNextToken(
          res.data.LDSpropertiesByStateAndTotalAssessedValue.nextToken
        );
        setIsLoading(false);
      });
    } else if (filterStr === "County" && searchStr) {
      setIsLoading(true);
      await API.graphql(
        graphqlOperation(lDSpropertiesByCountyAndTotalAssessedValue, {
          limit: limitNum,
          County: searchStr.toLowerCase().includes("county")
            ? searchStr.toUpperCase()
            : (searchStr + " County").toUpperCase(),
          sortDirection: "DESC",
        })
      ).then((res) => {
        const ldsProperties = [];
        ldsProperties.push(
          ...res.data.LDSpropertiesByCountyAndTotalAssessedValue.items
        );
        setLDSProperties(ldsProperties);
        setNextToken(
          res.data.LDSpropertiesByCountyAndTotalAssessedValue.nextToken
        );
        setIsLoading(false);
      });
    }
  };

  const fetchNextLDSpropertiesWithToken = async () => {
    limitNum = 35;
    try {
      if (!searchStr) {
        try {
          const ldsPropertiesData = await API.graphql(
            graphqlOperation(searchLDSproperties, {
              nextToken: nextToken,
              limit: limitNum,
              sort: {
                direction: "desc",
                field: "TotalAssessedValue",
              },
            })
          );
          setNextToken(ldsPropertiesData.data.searchLDSproperties.nextToken);
          const ldsProperties = LDSProperties;
          ldsProperties.push(
            ...ldsPropertiesData.data.searchLDSproperties.items
          );
          setLDSProperties(ldsProperties);
        } catch (error) {
          console.log(error);
          //   setErrorType(error.errors[0].errorType);
        }
      } else if (searchStr && nextToken && filterStr === "City") {
        await API.graphql(
          graphqlOperation(lDSpropertiesByCityAndTotalAssessedValue, {
            nextToken: nextToken,
            limit: limitNum,
            City: searchStr.toUpperCase(),
            sortDirection: "DESC",
          })
        ).then((res) => {
          const ldsProperties = LDSProperties;
          ldsProperties.push(
            ...res.data.LDSpropertiesByCityAndTotalAssessedValue.items
          );
          setLDSProperties(ldsProperties);
          setNextToken(
            res.data.LDSpropertiesByCityAndTotalAssessedValue.nextToken
          );
          setIsLoading(false);
        });
      } else if (searchStr && nextToken && filterStr === "State") {
        await API.graphql(
          graphqlOperation(lDSpropertiesByStateAndTotalAssessedValue, {
            nextToken: nextToken,
            limit: limitNum,
            State: searchStr.toUpperCase(),
            sortDirection: "DESC",
          })
        ).then((res) => {
          const ldsProperties = LDSProperties;
          ldsProperties.push(
            ...res.data.LDSpropertiesByStateAndTotalAssessedValue.items
          );
          setLDSProperties(ldsProperties);
          setNextToken(
            res.data.LDSpropertiesByStateAndTotalAssessedValue.nextToken
          );
          setIsLoading(false);
        });
      } else if (searchStr && nextToken && filterStr === "County") {
        await API.graphql(
          graphqlOperation(lDSpropertiesByCountyAndTotalAssessedValue, {
            nextToken: nextToken,
            limit: limitNum,
            County: searchStr.toLowerCase().includes("county")
              ? searchStr.toUpperCase()
              : (searchStr + " county").toUpperCase(),
            sortDirection: "DESC",
          })
        ).then((res) => {
          const ldsProperties = LDSProperties;
          ldsProperties.push(
            ...res.data.LDSpropertiesByCountyAndTotalAssessedValue.items
          );
          setLDSProperties(ldsProperties);
          setNextToken(
            res.data.LDSpropertiesByCountyAndTotalAssessedValue.nextToken
          );
          setIsLoading(false);
        });
      }
    } catch (error) {
      console.log("error on fetching LDS Properties", error);
    }
    // setIsLoading(false);
  };
  return (
    <>
      <Container>
        {!isLoading ? (
          <div className="form-row">
            <form
              style={{ marginTop: "2%" }}
              onSubmit={handleSubmitSearchString}
              className="form-group row container "
            >
              <label className="col-form-label" style={{ fontStyle: "oblique" }}>
                "Use the 2 letter state abbreviation to search for state Ex: ca,
                UT, Va, etc"
              </label>
              <br />
              <input
                className="col-4"
                type="text"
                value={searchStr}
                onChange={(e) => setSearchStr(e.target.value)}
              />
              <select
                className="col"
                style={{ marginLeft: "1%", top: "auto" }}
                onChange={(e) => setFilterStr(e.target.value)}
                id="options"
                name="options"
                value={filterStr}
              >
                <option value="City">City</option>
                <option value="State">State</option>
                <option value="County">County</option>
              </select>
              <input className="col" style={{ marginLeft: "1%", padding: "0" }} type="submit" />
              <div className="col-1" />
            </form>

            {!isMobile ? (
              <Container>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Address</th>
                      {/* <th /> */}
                      <th>City</th>
                      <th>State</th>
                      <th>County</th>
                      <th>Land Use</th>
                      <th>Acreage</th>
                      <th>Assessed Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {LDSProperties.map((p, idx) => {
                      return (
                        <tr key={p.id + 1}>
                          <td>
                            {" "}
                            <Button
                              variant="link"
                              onClick={() => handleShowDetail(p)}
                            >
                              {p.Address || "No Address"}
                            </Button>
                          </td>
                          {/* <td>
                            <Button
                              variant="link"
                              onClick={() => handleShowMap(p)}
                            >
                              map
                            </Button>
                          </td> */}
                          <td>{p.City}</td>
                          <td>{p.State}</td>
                          <td>{p.County}</td>
                          <td>{p.LandUseDescription}</td>
                          <td>{p.Acreage}</td>
                          <td>{"$" + p.TotalAssessedValue.toLocaleString()}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Container>
            ) : (
              <div style={{ fontSize: "0.6rem" }}>
                <Container>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Address</th>
                        {/* <th></th> */}
                        <th>City</th>
                        <th>State</th>
                        {/* <th>County</th>
                    <th>Land Use</th>
                    <th>Acreage</th> */}
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {LDSProperties.map((p, idx) => {
                        return (
                          <tr key={p.id + 1}>
                            <td>
                              {" "}
                              <Button
                                style={{ fontSize: "0.65rem" }}
                                variant="link"
                                onClick={() => handleShowDetail(p)}
                              >
                                {p.Address || "No Address"}
                              </Button>
                            </td>
                            {/* <td>
                              <Button
                              style={{ fontSize: "0.65rem" }}
                                variant="link"
                                onClick={() => handleShowMap(p)}
                              >
                                map
                              </Button>
                            </td> */}
                            <td>{p.City}</td>
                            <td>{p.State}</td>
                            {/* <td>{p.County}</td>
                        <td>{p.LandUseDescription}</td>
                        <td>{p.Acreage}</td> */}
                            <td>
                              {"$" + p.TotalAssessedValue.toLocaleString()}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Container>
              </div>
            )}
            <Modal
              size="lg"
              show={detailShow}
              onHide={() => setDetailShow(false)}
              aria-labelledby="restaurant-detail"
            >
              <Modal.Header closeButton>
                <Modal.Title id={`${pid}`}>{landUseDescription}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PropertyDetail pid={pid} />
              </Modal.Body>
            </Modal>

            {/* <Modal
              size="lg"
              show={mapShow}
              onHide={() => setMapShow(false)}
              aria-labelledby="map"
            >
              <MapBox p={currentProperty} />
            </Modal> */}
            {nextToken ? (
              <Button
                onClick={fetchNextLDSpropertiesWithToken}
                variant="outline-primary"
                style={{ marginBottom: "3%" }}
              >
                Load more
              </Button>
            ) : null}
          </div>
        ) : (
          <div style={{ textAlign: "center", margin: "3%" }}>
            <Spinner animation="grow" />
            <Spinner style={{ marginLeft: "2%" }} animation="grow" />
            <Spinner style={{ marginLeft: "2%" }} animation="grow" />
          </div>
        )}
      </Container>
    </>
  );
};

export default ListLDSProperties;
